import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme/utils';

export const CUSTOM_ACTION_CREATED_CLASS_NAME = 'CustomActionCreated';
export const CUSTOM_ACTION_CREATED_CLASS_SLOTS = ['root'] as const;

export type CustomActionCreatedClassSlot =
	(typeof CUSTOM_ACTION_CREATED_CLASS_SLOTS)[number];

export interface CustomActionCreatedClasses {
	root: string;
}

export type CustomActionCreatedClassKey = keyof CustomActionCreatedClasses;

export const getCustomActionCreatedUtilityClass = (slot: string) =>
	generateUtilityClass(CUSTOM_ACTION_CREATED_CLASS_NAME, slot);

export const customActionCreatedClasses = generateUtilityClasses<
	keyof CustomActionCreatedClasses
>(CUSTOM_ACTION_CREATED_CLASS_NAME, ['root']);
export default customActionCreatedClasses;
